<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="goBack()">
        <ion-icon
          slot="icon-only"
          name="chevron-back"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ chatTitle() }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <div class="chat">
    @for (item of items(); track item.id || $index) {
      <div
        class="chat-line"
        [class.client]="item.fromClient"
      >
        <!-- date delimiter -->
        @if (item.dateDelimiter) {
          <div class="date-delimiter">{{ item.createdAt | localeDate: locale : 'MMMM dd' }}</div>
        }

        <!-- message type -->
        @if (item.itemType === chatItemType.Message) {
          <div
            [class]="'message ' + getCorner($index)"
            [class.show-with-animation]="isAnimatedLastMessage() && items().length === $index + 1"
          >
            @if (!item.fromClient) {
              <span class="username">{{ item.username }}</span>
            }
            <div class="content">
              <div class="message-wrapper">
                @if (item.title) {
                  <p [class]="'title ' + getTitleColor(item.style)">{{ item.title }}</p>
                }
                @if (item.message) {
                  <p class="text">{{ item.message }}</p>
                }
              </div>
              <span class="date">{{ item.createdAt | utcTime: 'HH:mm' }}</span>
            </div>
          </div>
        }

        <!-- notice type -->
        @if (item.itemType === chatItemType.Notice) {
          <div
            [class.with-offset]="isOffset($index)"
            class="notice"
            [class.success]="item.style === 0"
            [class.warning]="item.style === 1"
            [class.danger]="item.style === 2"
          >
            <div class="status">
              <ion-icon [name]="item.icon"></ion-icon>
            </div>
            <div class="content">
              @if (item.title) {
                <p class="title">{{ item.title }}</p>
              }
              @if (item.message) {
                <p class="text">{{ item.message }}</p>
              }
              <span class="date">{{ item.createdAt | utcTime: 'HH:mm' }}</span>
            </div>
          </div>
        }

        <!-- information type -->
        @if (item.itemType === chatItemType.Information) {
          <div
            class="information"
            [class.with-offset]="isOffset($index)"
          >
            <div class="content-wrapper">
              <div class="status">
                <ion-icon [name]="item.icon"></ion-icon>
              </div>
              <span class="username">{{ item.username }}</span>
              <div class="content">
                <p class="title">{{ item.title }}</p>
                @if (item.message) {
                  <p class="text">{{ item.message }}</p>
                }
                <span class="extra">{{ item.extra }}</span>
              </div>
            </div>
            <span class="date">{{ item.createdAt | utcTime: 'HH:mm' }}</span>
          </div>
        }
      </div>
    }
  </div>
</ion-content>

<ion-footer [translucent]="true">
  <rota-send-bar>
    @if (type() === chatType.Requests) {
      <rota-requests-area
        area
        [applicationId]="id()"
        [applicationTitle]="chatTitle()"
      />
    }
    @if (type() === chatType.Enquiries) {
      <rota-enquiries-area
        area
        [applicationId]="id()"
        [applicationTitle]="chatTitle()"
      />
    }
  </rota-send-bar>
</ion-footer>
